import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const PublicNavbar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const navegarA = (ruta) => {
        if (ruta.startsWith('#')) {
            // Es una sección dentro de la página actual
            const elemento = document.getElementById(ruta.substring(1));
            if (elemento) {
                elemento.scrollIntoView({ behavior: 'smooth' });
            } else if (location.pathname !== '/') {
                // Si no estamos en home, navegar a home primero
                navigate('/');
                setTimeout(() => {
                    const el = document.getElementById(ruta.substring(1));
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                }, 100);
            }
        } else {
            // Es una ruta normal
            navigate(ruta);
        }
        setMobileMenuOpen(false);
    };

    const menuItems = [
        { label: 'Home', ruta: '#home' },
        { label: 'Nosotros', ruta: '/nosotros' },
        { label: 'Servicios', ruta: '#servicios' },
        { label: 'MiguelMX PRO', ruta: '#pro' },
    ];

    return (
        <nav
            className={`fixed w-full z-50 transition-all duration-300 ${scrolled
                ? "bg-white/95 backdrop-blur-lg border-b border-slate-200 shadow-sm"
                : "bg-white/90 backdrop-blur-lg"
                }`}
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center py-4">
                    {/* Logo */}
                    <button
                        onClick={() => navegarA('/')}
                        className="flex items-center space-x-3 hover:opacity-80 transition-opacity"
                    >
                        <img
                            src="https://static.wixstatic.com/media/755cdc_fba32a57a6554eb9b4205d19bf8f419e~mv2.png/v1/fill/w_518,h_98,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Logo%20verde.png"
                            alt="MiguelMX"
                            className="h-8 w-auto object-contain"
                            onError={(e) => {
                                e.target.style.display = 'none';
                                e.target.nextSibling.style.display = 'flex';
                            }}
                        />
                        <div className="w-32 h-8 bg-gradient-to-r from-[#14840c] to-green-700 rounded-lg items-center justify-center shadow-lg hidden">
                            <span className="text-white font-bold text-lg">MiguelMX</span>
                        </div>
                    </button>

                    {/* Desktop Menu */}
                    <div className="hidden md:flex items-center space-x-8">
                        {menuItems.map((item) => (
                            <button
                                key={item.label}
                                onClick={() => navegarA(item.ruta)}
                                className={`text-slate-700 hover:text-[#14840c] transition-colors font-medium ${location.pathname === '/' && item.ruta === '#home' ? 'text-[#14840c]' : ''
                                    }`}
                            >
                                {item.label}
                            </button>
                        ))}
                        <button
                            onClick={() => navegarA('/login')}
                            className="text-slate-700 hover:text-[#14840c] transition-colors font-medium"
                        >
                            Iniciar Sesión
                        </button>
                        <button
                            onClick={() => navegarA('/signup')}
                            className="bg-[#14840c] text-white px-6 py-2 rounded-lg hover:bg-green-700 transition-all duration-300 font-medium shadow-lg hover:shadow-xl hover:scale-105"
                        >
                            Registrarse
                        </button>
                    </div>

                    {/* Mobile Menu Button */}
                    <button
                        className="md:hidden text-[#14840c] p-2 rounded-lg hover:bg-green-50 transition-colors"
                        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                    >
                        {mobileMenuOpen ? (
                            <X className="w-6 h-6" />
                        ) : (
                            <Menu className="w-6 h-6" />
                        )}
                    </button>
                </div>
            </div>

            {/* Mobile Menu */}
            {mobileMenuOpen && (
                <div className="md:hidden bg-white/95 backdrop-blur-lg border-b border-slate-200 shadow-lg">
                    <div className="px-4 py-6 space-y-4">
                        {menuItems.map((item) => (
                            <button
                                key={item.label}
                                onClick={() => navegarA(item.ruta)}
                                className="block w-full text-left text-slate-700 hover:text-[#14840c] transition-colors font-medium py-2 px-2 rounded-lg hover:bg-green-50"
                            >
                                {item.label}
                            </button>
                        ))}
                        <div className="border-t border-slate-200 pt-4 space-y-2">
                            <button
                                onClick={() => navegarA('/login')}
                                className="block w-full text-left text-slate-700 hover:text-[#14840c] transition-colors py-2 px-2 font-medium rounded-lg hover:bg-green-50"
                            >
                                Iniciar Sesión
                            </button>
                            <button
                                onClick={() => navegarA('/signup')}
                                className="w-full bg-[#14840c] text-white px-6 py-3 rounded-lg font-medium hover:bg-green-700 transition-all duration-300 shadow-lg"
                            >
                                Registrarse
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </nav>
    );
};

export default PublicNavbar;